import React from 'react';
import multilanguage from "../assets/translate.png";
import ai from "../assets/chip.png";
import "./cards.css";
import imageRec from "../assets/imagerecogisation.png";

const cards = () => {
  return (
    <div className="main-div-container">
      <div className="logo-container">
      </div>
      <div>
        <h1 className="ascentHeading">Ascent Copilot</h1>
      </div>
      <h2 className="subHeading">Your AI Companion</h2>
      <div className="feature-container">
        <div className="container-item">
          <div className="feature-main">
            <div className="features">
              <div className="feature-card">
                <div className="d-flex headBox">
                  <img
                    src="./login-avail.svg"
                    alt="feature-availability"
                    className="icon1"
                  />
                  <h3>24/7 Availability</h3>
                </div>
                <span>Ascent Chatbot provide round-the-clock support.</span>
              </div>
              <div className="feature-card">
                <div className="d-flex headBox">
                  <img
                    src="./login-response.svg"
                    alt="feature-availability"
                    className="icon1"
                  ></img>
                  <h3>Instant Response</h3>
                </div>

                <span>Deliver immediate replies to user inquiries.</span>
              </div>
              <div className="feature-card">
                <div className="d-flex headBox">
                  <img
                    src="./login-consistency.svg"
                    alt="feature-availability"
                    className="icon1"
                  ></img>
                  <h3>Consistency</h3>
                </div>
                <span>Provide consistent responses & follow scripts.</span>
              </div>
              <div className="feature-card">
                <div className="d-flex headBox">
                  <img
                    src="./login-scalability.svg"
                    alt="feature-availability"
                    className="icon1"
                  ></img>
                  <h3>Scalability</h3>
                </div>
                <span>Handle numerous interactions simultaneously.</span>
              </div>
              <div className="feature-card">
                <div className="d-flex headBox">
                  <img
                    src={imageRec}
                    alt="feature-availability"
                    className="icon1"
                  ></img>
                  <h3>Image Recognition</h3>
                </div>
                <span>Ascent Chatbot can analyze images.</span>
              </div>
              <div className="feature-card">
                <div className="d-flex headBox">
                  <img
                    src={ai}
                    alt="feature-availability"
                    className="icon1"
                  ></img>
                  <h3>Data Privacy</h3>
                </div>
                <span>Do not store or share personal data provided.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default cards